module.exports = __webpack_public_path__ + "234f0eca42c378b999f48ffe2a771b20.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_medium_x1_variable/public/news/img1_3.jpg
// module id = 398
// module chunks = 0